import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { CountryCodes } from '../Helper/constants';

// Elements
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

export default class About extends Component {

    render() {
        let about = this.props.clinic.about;
        if(about.length === 0) {
            return <></>
        }
        let about_pic = "/img/about-pic.jpeg";
        if(this.props.clinic.about_pic !== undefined) {
            about_pic = this.props.clinic.about_pic;
        }
        const has_mobile = this.props.clinic.contact.mobile.length > 0;
        const contact_url = has_mobile ? "tel:" + CountryCodes.india + this.props.clinic.contact.mobile[0] : null;
        const team_size = this.props.clinic.team.length;
        return (
            <div className="space-medium about-modern">
                <Container>
                    <Row className="align-items-start">
                        <Col lg={6} md={6} sm={12} xs={12} className='wow fadeInLeft' data-wow-duration="1.3s" data-wow-delay="0.3s">
                            <div className="about-media">
                                <div className="about-media__dots"></div>
                                <div className="about-media__dots about-media__dots--end"></div>
                                <img src={about_pic} alt="clinic" className="about-media__img"/>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} xs={12} className='wow fadeInRight' data-wow-duration="1.3s" data-wow-delay="0.3s">
                            <div className="about-section">
                                <span className="about-eyebrow">About us</span>
                                <h1 className="about-title-modern">{this.props.clinic.name}</h1>
                                <div dangerouslySetInnerHTML={{__html:this.props.clinic.about}} className='about-list'></div>
                                {this.props.clinic.holiday.enabled?
                                <p className='holiday-notice ui-notice'>
                                    <i className="fa-solid fa-circle-info"></i>
                                    <span>
                                        <b>Notice:</b> Clinic closed
                                        {this.props.clinic.holiday.start===this.props.clinic.holiday.end?
                                        <> on {this.props.clinic.holiday.start}. </>:<> from {this.props.clinic.holiday.start} to {this.props.clinic.holiday.end}. </>}
                                        Please avoid booking appointments. Thank you.
                                    </span>
                                </p>:null}
                                <div className="about-actions">
                                    <Link to="/appointment" className="ui-btn ui-btn--primary">
                                        <i className="fa-regular fa-calendar-check"></i>
                                        <span>Book Appointment</span>
                                        <i className="fa-solid fa-arrow-right ui-btn__arrow"></i>
                                    </Link>
                                    {has_mobile ?
                                    <a href={contact_url} className="ui-btn ui-btn--ghost">
                                        <i className="fa-solid fa-phone"></i>
                                        <span>Call Us</span>
                                    </a> : null}
                                </div>
                                {this.props.as_section && team_size > 0 ?
                                <Link to="/about" className="text-link">Meet our team <i className="fa-solid fa-arrow-right"></i></Link>
                                :null}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}
